import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ContextStateService } from '@core/services/context-state.service';

export const redirectProjectAnalyticsToModuleGuard: CanActivateFn = () => {
    const router = inject(Router);
    const moduleSlug = inject(ContextStateService).selectedModuleSlug();
    if (!moduleSlug) {
        return router.createUrlTree(['/']);
    }

    return router.createUrlTree(['/', moduleSlug, 'analytics']);
};
